import { render, staticRenderFns } from "./LoanRelationWApplicantIFC.vue?vue&type=template&id=28f23c26&"
import script from "./LoanRelationWApplicantIFC.vue?vue&type=script&lang=js&"
export * from "./LoanRelationWApplicantIFC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports